import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { translate } from "../../components/Language/Translate";
import { Form } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Spinner from "../../components/Spinner";
import FormFields from "../FormFields";
import CompanySchema from "./CompanySchema";
import FormValidation from "../Validation/FormValidation";
import { simpleRequest } from "../../newForms2/simpleRequest";
import { useDispatch } from "react-redux";
import { addCompanyOnAPI } from "../../actions/companies";


const CompanyNew = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [variables, setVariables] = useState({});
  const [fieldSettings, setFieldSettings] = useState({});
  const [success, setSuccess] = useState(false);
  const [serverError, setServerError] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  const history = useHistory();
  const dispatch = useDispatch();

  console.log("inside CompanyNew in newforms2", variables);

  useEffect(() => {
    console.log("inside useEffect");
    const fetch = () => {
      const sets = new CompanySchema();
      (() => setFieldSettings({ ...sets.fields }))();
      const vars = {};
      Object.entries(sets.fields).forEach(
        (v) => (vars[v[0]] = v[1].initialValue)
      );
      (() => setVariables(vars))();
      (() => setIsLoading(false))();
    };
    if (isLoading) fetch();
  }, [isLoading, setFieldSettings, setVariables, setIsLoading]);

  if (isLoading) return <Spinner />;

  const handleSubmit = async (e) => {

    e.preventDefault();
    console.log("inside handle Submit")
    const formValidation = new FormValidation({ fieldSettings, variables });
    console.log({formValidation})
    if (!formValidation.valid) return;
    const data = { ...variables };
    dispatch(addCompanyOnAPI(data))
    history.push('/companies')
  };
  const props = {
    fieldSettings,
    variables,
    setVariables,
    fieldErrors,
    setFieldErrors,
    serverError,
  };

  return (
    <div>
      <h4>Neuen Schule hinzufügen</h4>
      {!success && (
        <Form onSubmit={(e) => handleSubmit(e)}>
          <FormFields props={props} />
          <Button block size="lg" type="submit">
            {translate("Add Company")}
          </Button>
        </Form>
      )}
      {success && <h5>{translate("Company successfully added")}.</h5>}
    </div>
  );
};
export default CompanyNew;
